var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BadgeUi',{staticClass:"product-card-price-diff",class:_vm.type ? 'product-card-price-diff--' + _vm.type : '',attrs:{"type":"primary"}},[_c('span',{staticClass:"product-card-price-diff__value"},[_vm._v("-"+_vm._s(_vm.data.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }